import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import { installGoogleTranslateGuard } from "./googleTranslateGuard";
import {
  replayIntegrationOptions,
  sentryInitOptions,
  shouldInitSentry,
  shouldRecordReplayForEvent,
} from "./utils/sentryConfig";

// Must run before the first render: patches removeChild/insertBefore so
// Chrome's page translation re-parenting text nodes no longer crashes React
// and tears the checkout down (PLATAFORMA-N). See googleTranslateGuard.ts.
installGoogleTranslateGuard();

if (shouldInitSentry(process.env.REACT_APP_NODE_ENV)) {
  Sentry.init({
    dsn: "https://72646154e85574e72b2e6e7c3405c1d3@o4510668927860736.ingest.us.sentry.io/4511076900143104",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        ...replayIntegrationOptions,
        // Handled (non-crash) errors are tagged handled:true and must NOT pull a
        // replay — see shouldRecordReplayForEvent. Protects the replay quota.
        beforeErrorSampling: shouldRecordReplayForEvent,
      }),
    ],
    ...sentryInitOptions,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
